import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse  } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';


@Injectable({
    providedIn: 'root',
  })

  export class Posvendoradjustmentservice {
    private baseURL: string;
    constructor(private http: HttpClient) {
      this.baseURL = environment.apiBaseUrl;
    }

    getPosVendorAdjDetails(): Observable<any> {
        return this.http.get<any>(
          `${this.baseURL}/POSVendorAdj/GetPosVendorAdjDetails`,
          { observe: 'response' }
        ).pipe(
          map((res: HttpResponse<any>) => res.body),
          catchError(this.handleError)
        );
      }

      saveVendorAdjustment(SalesPersonDetail: any): Observable<any> {
        return this.http.post<any>(
          `${this.baseURL}/POSVendorAdj/SaveVendorAdjustment`,
          SalesPersonDetail,
          { observe: 'response' }
        ).pipe(
          map((res: HttpResponse<any>) => res.body),
          catchError(this.handleError)
        );
      }

      deleteVendorAdjustment(id: number): Observable<any> {
        return this.http.delete<any>(
          `${this.baseURL}/POSVendorAdj/DeleteVendorAdjustment/${id}`,
          { observe: 'response' }
        ).pipe(
          map((res: HttpResponse<any>) => res.body),
          catchError(this.handleError)
        );
      }
      
      private handleError(error: HttpErrorResponse) {
        if (error.error instanceof Error) {
           const errMessage = error.error.message;
           return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
     }
  }  